import React from 'react';

const DeleteSubscriptionModal = ({ subscription, actionLoading, onDelete, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold text-red-600 mb-4">Delete Subscription</h3>
        <p className="text-gray-600 mb-4">
          Are you sure you want to permanently delete the subscription for <strong>{subscription.customer_name || subscription.customerName}</strong>?
        </p>
        <p className="text-sm text-red-500 mb-4">
          Warning: This action cannot be undone. All subscription data will be permanently removed.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
            disabled={actionLoading}
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
            disabled={actionLoading}
          >
            {actionLoading ? 'Deleting...' : 'Delete Permanently'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteSubscriptionModal;